import { Icon } from './Icons';
import { formatPrice, formatInches } from '../lib/format';

export function PricingCard({ quote, copy, currency, allAck, onAddToCart }) {
  if (!quote) {
    return (
      <div className="card pricing-card">
        <div className="pc-eyebrow">{copy.pricing_eyebrow}</div>
        <p className="muted small" style={{ margin: '12px 0 0' }}>Add files to see pricing.</p>
      </div>
    );
  }
  const blocked = !!quote.blockReason;
  return (
    <div className="card pricing-card">
      <div className="pc-head">
        <span className="pc-eyebrow">{copy.pricing_eyebrow}</span>
      </div>
      <div className="pricing-rows">
        <div className="pr-row">
          <span>{copy.pricing_length_label}</span>
          <span className="mono">{formatInches(quote.totalInches)} <span className="muted">{copy.pricing_running_label}</span></span>
        </div>
        {quote.tier && (
          <div className="pr-row">
            <span>{copy.pricing_rate_label}</span>
            <span className="mono muted">{formatPrice(quote.tier.rate, currency)} / inch</span>
          </div>
        )}
      </div>
      <div className="pr-divider" />
      <div className="pr-total">
        <span>{copy.pricing_total_label}</span>
        <span className="mono pr-total-amt">{formatPrice(quote.total, currency)}</span>
      </div>
      {blocked && (
        <p className="small" style={{ color: 'var(--poor)', marginTop: 12 }}>{quote.blockReason}</p>
      )}
      <button
        type="button"
        className={`btn-cart${(blocked || !allAck) ? ' is-disabled' : ''}`}
        disabled={blocked || !allAck}
        onClick={onAddToCart}
      >
        <span>{allAck ? copy.cta_add_to_cart : copy.cta_required_acks}</span>
        <span className="mono">{formatPrice(quote.total, currency)}</span>
      </button>
      <div className="pc-foot">
        <Icon.Lock width="12" height="12" />
        <span>Secure checkout</span>
      </div>
    </div>
  );
}
